@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.assetChipRoot {
  display: flex;
  align-items: center;
  @include border-radius-r2;
  border: 1px solid var(--border-default);
  overflow: hidden;
  box-sizing: border-box;
}

.entity {
  display: flex;
  align-items: center;
  gap: 8px;
}

.assetLogoContainer {
  border-radius: 50%;
}

.ticker {
  @include typography-v2-body-sm;
}

%styledButton {
  background: none;
  border: none;
  color: inherit;
  outline: none;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background-color: var(--surface-hover);
  }
}

.entityButton {
  @extend %styledButton;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 2px 6px 8px;
}

.watchlistButton {
  @extend %styledButton;
  padding: 6px 8px 6px 2px;

  svg {
    fill: var(--icon-default);
  }

  &.isActive svg {
    fill: var(--icon-success);
  }
}

.iconWrapper {
  display: flex;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
